import MemberSearchVue from '@/views/sa/member-search/member-search.vue';

const basePath = '/sa/member-search';
const role = 'sa'; // 角色身份

export const SA_MEMBER_SEARCH_INDEX = 'sa-member-search-index';
export const SA_MEMBER_SEARCH_SHOW = 'sa-member-search-show';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MemberSearchVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_MEMBER_SEARCH_INDEX,
      component: () => import(
        /* webpackChunkName: "member search" */
        `@/views/${role}/member-search/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/show`,
      name: SA_MEMBER_SEARCH_SHOW,
      component: () => import(
        /* webpackChunkName: "member show" */
        `@/views/${role}/member-search/show.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
